
export const transform = ({
							  id,
							  report_id,
							  name,
							  timestamp,
}) => (
	{
		id: id,
		name: name,
		report_id: report_id,
		timestamp: timestamp,
	}
);
